import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/verify/$qrCode")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/track/$code",
      params: { code: params.qrCode },
    });
  },
  component: () => null,
});
